import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import UAParser from "ua-parser-js";
import EventBus from "../../../../common/EventBus.js";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import FormRow from "../../../../common/form/row.component.jsx";
import Icon from "../../../../common/icon/icon.component.jsx";
import SignaturePadModal from "../../../../common/signature/modal.component.jsx";
import LoadingSpinner from '../../../../common/spinner/loading.component.jsx';
import SectionWrapper from "../../sectionwrapper.component.jsx";
import SavedSignature from './SavedSignatureComponent';

class SignatureContentSection extends Component {
    constructor(props, context) {
        super(props, context)
        const name = this.getDefaultName(this.props.section, this.props.variables)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            isDummy: this.props.isDummy === true,
            isPdf: this.props.isPdf === true,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            included: this.props.included || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            loading: false,
            firstName: name.firstName,
            lastName: name.lastName,
            signature: '',
            signaturePad: '',
        }

        this.openPayMode = this.openPayMode.bind(this)
        this.confirm = this.confirm.bind(this)
        this.openSignaturePad = this.openSignaturePad.bind(this)
        this.handleSignaturePadClose = this.handleSignaturePadClose.bind(this)
        this.fetchDisableChatAttribute = this.fetchDisableChatAttribute.bind(this)
    }   

    componentWillReceiveProps(nextProps) {
        const name = this.getDefaultName(nextProps.section, nextProps.variables)
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy === true,
            id: nextProps.id || '',
        })
    }

    getDefaultName(section, variables) {
        if (!section || !variables) {
            return {
                firstName: '',
                lastName: '',
            }
        }
        return {
            firstName: section.attributes.content.firstName || variables.customer.firstName,
            lastName: section.attributes.content.lastName || variables.customer.lastName,
        }
    }

    componentDidMount() {

    }

    openPayMode(e) {
        e.preventDefault()
        this.setState({
            payMode: true
        })
    }

    confirm(signature) {
        let error = ""
        if (!this.state.firstName || !this.state.lastName || !signature) {

            error = <div className={"w-100"}>
                <small className={"text-danger"}>
                    <FormattedMessage
                        id="proposal.signature.error_required_message_signature"
                        defaultMessage="Signer's first, last name and signature are required"
                    />
                </small>
            </div>

        } else {
            const transaction = {
                amount: String(this.getPaymentAmount()),
            }
            this.setState({
                signature: signature
            })
            if (this.state.variables.document.type === 'invoice') {
                transaction.invoiceId = this.state.variables.quote.id
            }
            if (this.state.variables.document.type === 'quote') {
                transaction.quoteId = this.state.variables.quote.id
            }

            AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/sign', {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                signature: signature,
                fingerprintId: GlobalHelper.getFingerprintId(),
                sectionId: this.state.section.id,
            }).then(res => {
                if (res.error) {
                    error = <div className={"w-100"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                } else {
                    this.setState({
                        variables: res.attributes.variables,
                        loading: false,
                    })
                    EventBus.dispatch(EventBus.TopicProposalRefresh, {
                        variables: res.attributes.variables
                    })
                }
            })
        }
        return error
    }

    getPaymentAmount() {
        return this.state.variables.quote.needDepositPayment ?
            this.state.variables.quote.depositBalance :
            this.state.variables.quote.balance

    }

    openSignaturePad(event) {
        event.preventDefault()
        this.setState({
            loading: true,
            signaturePad: <SignaturePadModal
                onClose={this.handleSignaturePadClose}
                onConfirm={this.confirm}
                btnStyle={{
                    outlineColor: this.state.variables.global.buttonColor,
                    backgroundColor: this.state.variables.global.buttonColor,
                    borderColor: this.state.variables.global.buttonColor,
                }}
            />
        })

        EventBus.dispatch(EventBus.TopicSignaturePadChanged, {
            hideChatButton: true,
        })
    }

    fetchDisableChatAttribute() {
        const { sections } = this.state.variables || []
        const docInfoSection = sections?.find(section => section?.attributes?.internalName === "documentInfo") ?? []
        return docInfoSection?.attributes?.content?.disableChat || false
    }

    handleSignaturePadClose(updated) {
        let attributesToUpdate = { signaturePad: '' }
        if (!updated) {
            attributesToUpdate['loading'] = false
        }

        this.setState(attributesToUpdate)
        let hideChatButton = this.fetchDisableChatAttribute()
        EventBus.dispatch(EventBus.TopicSignaturePadChanged, {
            hideChatButton: hideChatButton,
        })
    }

    getSavedSignature() {
        return this.state.variables.document.signatures.filter(s => s.attributes.sectionId === this.state.section.id)[0]
    }

    render() {
        if (!this.state.section) {
            return <div />
        }
        const savedSignature = this.getSavedSignature()
        let fingerprint = {}
        let userAgent = {}
        if (savedSignature) {
            fingerprint = savedSignature.attributes.fingerprint
            const parser = new UAParser()
            parser.setUA(fingerprint.attributes.userAgent)
            userAgent = parser.getResult()
        }

        const medium = this.state.isPdf ? ' col-md-6 ' : ' col-md-12 '
        const signClassName = this.state.isPdf ? ' col-6 ' : ' col-lg-6 col-12 '

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                included={this.state.included}
            >
                <div className={'col-12'}>
                    <div className={'row px-2 border-top py-2 mt-2'}>
                        {this.state.signaturePad}
                        {savedSignature ?
                            <SavedSignature
                                signClassName={signClassName}
                                fingerprint={fingerprint}
                                userAgent={userAgent}
                                medium={medium}
                                savedSignature={savedSignature}
                            /> :
                            <div className={'col-12'}>
                                {this.state.loading ? <LoadingSpinner marginTop="20px" /> :
                                    <div className={'row'}>
                                        <div className={signClassName}>
                                            <FormRow
                                                className={"mb-2"}
                                                style={"rows"}
                                                name={"firstName"}
                                                label={<FormattedMessage
                                                    id="proposal.signature.first_name_label"
                                                    defaultMessage="Signer's first name"
                                                />}
                                                input={<input required id={"firstName"} type={"text"} className="form-control" value={this.state.firstName} onChange={e => {
                                                    this.setState({
                                                        firstName: e.target.value
                                                    })
                                                }} />}
                                            />
                                            <FormRow
                                                className={"mb-0"}
                                                style={"rows"}
                                                name={"lastName"}
                                                label={<FormattedMessage
                                                    id="proposal.signature.last_name_label"
                                                    defaultMessage="Signer's last name"
                                                />}
                                                input={<input required id={"lastName"} type={"text"} className="form-control" value={this.state.lastName} onChange={e => {
                                                    this.setState({
                                                        lastName: e.target.value
                                                    })
                                                }} />}
                                            />
                                        </div>
                                        {!this.state.signature && <div className={signClassName + ' d-flex py-lg-0 py-5 align-items-center justify-content-center border-bottom border-dark'}>
                                            {!this.state.isPdf && <button className="btn btn-primary" onClick={this.openSignaturePad} style={{
                                                outlineColor: this.state.variables.global.buttonColor,
                                                backgroundColor: this.state.variables.global.buttonColor,
                                                borderColor: this.state.variables.global.buttonColor,
                                            }} >
                                                <Icon value={'signature'} className={'mr-1'} />
                                                <FormattedMessage
                                                    id="proposal.signature.edit_signature_btn"
                                                    defaultMessage="Click here to sign"
                                                />
                                            </button>}
                                        </div>}
                                    </div>}
                            </div>}
                    </div>
                </div>

            </SectionWrapper>
        );
    }
}

export default injectIntl(SignatureContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/signature/section.component.jsx